<template>
    <b-card no-body>
        <div class="row p-2 align-items-end">
            <div class="col-md-3 mb-1">
                <label class="form-label">Gün (önümüzdeki)</label>
                <input type="number" min="1" max="90" class="form-control" v-model.number="days" placeholder="Gün" />
            </div>
            <div class="col-md-2 mb-1">
                <v-executer :loading="loading" :action="getData">Filtrele</v-executer>
            </div>
            <div class="col-md-7 mb-1 text-right">
                <p class="mb-0">Önümüzdeki <strong>{{ afterFilterDays }}</strong> gün içinde vadesi dolacak açık alacaklar. Toplam: <strong>{{ report.GrandTotal }}</strong></p>
            </div>
        </div>

        <table class="table">
            <thead>
                <tr>
                    <th class="text no-wrap">Cari Kod</th>
                    <th class="text no-wrap">Cari Adı</th>
                    <th class="text no-wrap">Plasiyer</th>
                    <th class="text no-wrap">Belge No</th>
                    <th class="text no-wrap">Vade Tarihi</th>
                    <th class="text no-wrap">Kalan Gün</th>
                    <th class="text no-wrap">Kalan Borç</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in report.Items" :key="index">
                    <td>{{ item.CustomerCode }}</td>
                    <td>{{ item.CustomerName }}</td>
                    <td>{{ item.PlasiyerCode }}</td>
                    <td>{{ item.InvoiceNo }}</td>
                    <td>{{ item.VadeTarihi }}</td>
                    <td>{{ item.RemainingDays }}</td>
                    <td>{{ item.RemainingDebt }}</td>
                </tr>
                <tr v-if="!loading && report.Items.length === 0">
                    <td colspan="7" class="text-center text-muted">Bu pencerede vadesi yaklaşan tahsilat bulunamadı.</td>
                </tr>
            </tbody>
        </table>
    </b-card>
</template>
<script>
import { ReportApi } from '@/api/report'
import { BCard } from 'bootstrap-vue'

export default {
    components: {
        BCard
    },
    data() {
        return {
            loading: false,
            days: 7,
            afterFilterDays: 7,
            report: {
                Items: [],
                GrandTotal: ""
            }
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            this.loading = true
            ReportApi.UpcomingDueCollectionsReport({ Days: this.days }).then(res => {
                this.loading = false
                this.afterFilterDays = this.days
                this.report = res.data.Data
            }).catch(() => {
                this.loading = false
            })
        }
    }
}
</script>
